export default function useHaversine() {

    const toRadians = (degrees) => {
        return degrees * Math.PI / 180;
    }

    const haversineDistance = (lat1, lon1, lat2, lon2) => {
        const R = 6371e3;  // Earth's radius in meters

        const φ1 = toRadians(lat1);
        const φ2 = toRadians(lat2);
        const Δφ = toRadians(lat2 - lat1);
        const Δλ = toRadians(lon2 - lon1);

        const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
            Math.cos(φ1) * Math.cos(φ2) *
            Math.sin(Δλ / 2) * Math.sin(Δλ / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return R * c;
    }

    return { haversineDistance };
}
